export const BAR_POS_CONFIG = Object.freeze({
  bottlesEnabled: true,
  initialSection: "BOTTLE",
  cashSessionRoute: "/cashier/cash-session",
  saleDetailRoute: (saleId) => `/cashier/sales/${saleId}`,
  sections: [
    { id: "BOTTLE", label: "Liquor", productSections: [], customItemButton: false, activeClass: "bg-rose-50 shadow text-rose-700", icon: "wine" },
    { id: "BEVERAGE", label: "Beverages", productSections: ["BEVERAGE"], customItemButton: true, activeClass: "bg-sky-50 shadow text-sky-700", icon: "coffee" },
    { id: "FOOD", label: "Food & Bites", productSections: ["FOOD", "GOODS"], customItemButton: true, activeClass: "bg-yellow-50 shadow text-yellow-700", icon: "food" },
  ],
});

export const RESTAURANT_POS_CONFIG = Object.freeze({
  bottlesEnabled: false,
  initialSection: "FOOD",
  cashSessionRoute: "/res-cashier/cash-session",
  saleDetailRoute: (saleId) => `/res-cashier/sales/${saleId}`,
  sections: [
    { id: "FOOD", label: "Food", productSections: ["FOOD", "GOODS"], customItemButton: true, activeClass: "bg-yellow-50 shadow text-yellow-700", icon: "food" },
    { id: "BEVERAGE", label: "Beverage", productSections: ["BEVERAGE"], customItemButton: true, activeClass: "bg-sky-50 shadow text-sky-700", icon: "coffee" },
  ],
});
